module.exports = __webpack_public_path__ + "img/spritz-serving1.f6a14ee7.svg";